// extracted by mini-css-extract-plugin
export var quillEditor = "_ol-1";
export var variable = "_ol-0";